import Switch from 'core/components/inputs/Switch'
import cn from 'utils/cn'
import { Settings, useSettings } from 'core/hooks/settings/useSettings'
import React from 'react'

type FeatureFlagName = keyof Settings['featureFlags']

const FeatureFlagTab = () => {
  const {
    data: { featureFlags },
    set
  } = useSettings()

  return (
    <>
      <p className="text-base text mt-3">
        These flags control features in the app.
      </p>
      <hr className="mt-5" />
      <p className="text-center pt-1 subtitle-2">Everlance feature flags</p>
      <div className="w-full mt-8">
        {Object.entries(featureFlags).map(([name]) => {
          const isDriverExperience = ['ENABLE_DRIVER_EXPERIENCE'].includes(name)
          // Hide flags that are already approved
          const activeFlags: string[] = ['ENABLE_OUTLIERS_2']
          const isActive = featureFlags[name as FeatureFlagName]

          return activeFlags.includes(name) &&
            process.env.NODE_ENV === 'production' ? null : (
            <div key={name}>
              {isDriverExperience && (
                <div className="my-5">
                  <hr />
                  <p className="text-center pt-1 subtitle-2">
                    Motus feature flags
                  </p>
                </div>
              )}
              <div className="grid grid-cols-2 gap-2 mb-2">
                <div className="text-base ">
                  <pre>
                    <code className="text-dark font-extralight">{name}</code>
                  </pre>
                </div>
                <div className="flex justify-end">
                  <Switch
                    className={cn([
                      isDriverExperience && isActive && 'bg-motus-primary!',
                      !isDriverExperience && isActive && 'bg-everlance-primary!'
                    ])}
                    onChange={(active) => {
                      set('featureFlags', {
                        ...featureFlags,
                        [name]: active
                      })
                    }}
                    value={isActive}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default React.memo(FeatureFlagTab)
